import axios from 'axios';

export const insuranceDetails = (data) => {
  return axios({
    method: 'POST',
    url: 'me/insurance-details',
    data: data,
  });
};
